// @flow

import { combineReducers } from 'redux-immutable';

import lista from './lista';
import detalhes from './detalhes';
import novo from './novo';

export default combineReducers({ lista, detalhes, novo });